import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "rgb(255, 255, 255, 0",
  borderRadius: "2%",
  boxShadow: 24,
  p: 4,
  "@media": {
    width: "80%",
  },
};

function srcset(image: string, size: number, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export default function QuiltedImageList(images: Array<any>) {
  const [open, setOpen] = React.useState(false);
  const [modalImg, setModalImg] = React.useState("");
  function handleOpen(e: any) {
    setModalImg(e);
    setOpen(true);
  }
  const handleClose = () => setOpen(false);

  return (
    <>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box
              component="img"
              sx={{
                // position: "absolute",
                display: "block",
                overflow: "hidden",
                width: "100%",
                marginTop: "2%",
                height: "500px",
                objectFit: "contain",
                // "@media": {
                //   objectFit: "scale-down",
                // },
              }}
              loading="lazy"
              src={modalImg}
            />
          </Box>
        </Modal>
      </div>
      <ImageList
        sx={{
          maxWidth: 500,
          height: 450,
          "@media (max-width 768px)": {
            maxWidth: 345,
          },
        }}
        variant="quilted"
        cols={3}
        rowHeight={121}
      >
        {images.map((item) => (
          <ImageListItem
            key={item.img}
            cols={item.cols || 1}
            rows={item.rows || 1}
          >
            <img
              onClick={() => handleOpen(item.img)}
              {...srcset(item.img, 121, item.rows, item.cols)}
              alt={item.title}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </>
  );
}
